<script>
import imgPlaceholder from "../assets/img/avatar.jpg";

export default {
  name: "BioCard",
  props: {
    data: { type: Object, default: () => ({}) },
    fields: { type: Array, default: () => [] },
  },
  data: () => ({ imgPlaceholder }),
  computed: {
    identity() {
      return this.data?.userId || {};
    },
    displayName() {
      return [
        this.identity.firstName,
        this.identity.otherName,
        this.identity.lastName,
      ]
        .filter(Boolean)
        .join(" ");
    },
  },
  methods: {
    getValue(path) {
      return path.split(".").reduce((value, key) => value?.[key], this.data);
    },
    handleImageError(event) {
      event.target.src = this.imgPlaceholder;
    },
    badge(status) {
      return (
        {
          active: "bg-success",
          inactive: "bg-secondary",
          suspended: "bg-warning",
          terminated: "bg-danger",
        }[status] || "bg-secondary"
      );
    },
  },
};
</script>

<template>
  <div class="card border-0 shadow-sm">
    <div class="card-img-top d-flex justify-content-center mt-4">
      <img
        :src="identity.profileImageUrl || imgPlaceholder"
        class="rounded-circle"
        width="100"
        height="100"
        alt="Profile"
        @error="handleImageError"
      />
    </div>
    <div class="card-body">
      <h6 class="text-center text-capitalize">{{ displayName }}</h6>
      <div class="my-3 small">
        <div v-for="field in fields" :key="field.key" class="row mb-2">
          <div class="col-5 text-end fw-bold pe-0 text-secondary">
            {{ field.label }}
          </div>
          <div class="col-7 text-start">
            <span
              v-if="field.label === 'Status'"
              class="badge"
              :class="badge(data.status)"
              >{{ getValue(field.key) || "N/A" }}</span
            ><span v-else>{{ getValue(field.key) || "N/A" }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
